/**
 * SAPBusinessOneConnector — SAP B1 REST API adapter.
 * Sync: items + POs.
 */

import IntegrationService, { isMockMode } from '../IntegrationService';
import DataService from '../DataService';

const ENV_KEY = 'SAP_B1_API_KEY';

export const SAP_B1_FIELD_PRESETS = [
  { sourceField: 'ItemCode', kairosField: 'items.sku' },
  { sourceField: 'ItemName', kairosField: 'items.description' },
  { sourceField: 'OnHand', kairosField: 'items.onHand' },
  { sourceField: 'DocNum', kairosField: 'orders.poNumber' },
  { sourceField: 'CardName', kairosField: 'customers.name' },
];

const MOCK_ITEMS = [
  { sku: 'SAP-ITM-3301', itemNo: 'SAP-ITM-3301', description: 'Industrial Bearing — Heavy Duty', uomBase: 'EA', onHand: 180, cost: 45.50, price: 79.95, warehouseId: 'HOU' },
  { sku: 'SAP-ITM-3302', itemNo: 'SAP-ITM-3302', description: 'Steel Plate — 1/4" × 4ft × 8ft', uomBase: 'EA', onHand: 24, cost: 210.00, price: 389.00, warehouseId: 'HOU' },
  { sku: 'SAP-ITM-3303', itemNo: 'SAP-ITM-3303', description: 'Electrical Conduit — 3/4" EMT 10ft', uomBase: 'EA', onHand: 420, cost: 12.50, price: 24.95, warehouseId: 'HOU' },
  { sku: 'SAP-ITM-3304', itemNo: 'SAP-ITM-3304', description: 'Weld Rod — 7018 1/8" 50lb', uomBase: 'BOX', onHand: 38, cost: 189.00, price: 329.00, warehouseId: 'HOU' },
  { sku: 'SAP-ITM-3305', itemNo: 'SAP-ITM-3305', description: 'Safety Harness — Class A', uomBase: 'EA', onHand: 62, cost: 58.00, price: 109.00, warehouseId: 'HOU' },
];

async function sync(connector) {
  const mock = isMockMode(ENV_KEY);
  let created = 0;
  for (const item of MOCK_ITEMS) {
    await DataService.create('items', {
      ...item,
      tenantId: connector.tenantId,
      syncedFromConnectorId: connector.id,
      syncedAt: new Date().toISOString(),
      source: 'sap_b1',
    }, 'sap_b1_sync', 'sap_b1');
    created++;
  }
  return {
    recordsIn: created,
    recordsOut: 0,
    errors: 0,
    status: 'success',
    summary: mock ? `Mock SAP B1 sync — ${created} items` : `SAP B1 sync — ${created} items`,
  };
}

async function healthCheck() {
  if (isMockMode(ENV_KEY)) return { health: 'green', error: null };
  return { health: 'yellow', error: 'Live SAP B1 health check not yet implemented' };
}

IntegrationService.register('sap_b1', {
  label: 'SAP Business One',
  category: 'erp',
  description: 'Items + POs via SAP B1 REST',
  icon: '🏢',
  envKey: ENV_KEY,
  setupComponent: 'SAPSetup',
  defaultInterval: 30,
  directions: ['inbound'],
  capabilities: ['items_sync', 'orders_sync'],
  sync,
  healthCheck,
});

export default { connectorType: 'sap_b1', PRESETS: SAP_B1_FIELD_PRESETS };
